import { render, staticRenderFns } from "./DossierReopen.vue?vue&type=template&id=3ffa728c&scoped=true"
import script from "./DossierReopen.vue?vue&type=script&lang=js"
export * from "./DossierReopen.vue?vue&type=script&lang=js"
import style0 from "./DossierReopen.vue?vue&type=style&index=0&id=3ffa728c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffa728c",
  null
  
)

export default component.exports